import { useState } from "react";
import { Box, TextField, Typography, InputAdornment } from "@material-ui/core";
import { Button } from "@mui/material";
import { useTranslation } from "react-i18next";

const AddDoctorForm = ({ onAdd, onCancel, isLoading }) => {
  const { t } = useTranslation();
  const [firstName, setFirstName] = useState("");
  const [lastName, setLastName] = useState("");
  const [errors, setErrors] = useState({ firstName: false, lastName: false });

  const handleSubmit = () => {
    const newErrors = {
      firstName: !firstName.trim(),
      lastName: !lastName.trim(),
    };

    setErrors(newErrors);

    if (firstName.trim() && lastName.trim()) {
      onAdd(firstName.trim(), lastName.trim());
      handleReset();
    }
  };

  const handleReset = () => {
    setFirstName("");
    setLastName("");
    setErrors({ firstName: false, lastName: false });
  };

  const handleCancel = () => {
    handleReset();
    onCancel();
  };

  return (
    <Box>
      <Typography variant="h5" gutterBottom>
        {t("add-doctor-title")}
      </Typography>
      <Typography variant="subtitle1" color="textSecondary" gutterBottom>
        {t("add-doctor-description")}
      </Typography>
      <Typography
        variant="body2"
        gutterBottom
        style={{ fontWeight: 700, color: "#FF2C46" }}
      >
        {t("add-doctor-description-note")}
      </Typography>
      <TextField
        fullWidth
        required
        label={t("First-Name")}
        value={firstName}
        onChange={(e) => {
          setFirstName(e.target.value);
          setErrors((prev) => ({ ...prev, firstName: false }));
        }}
        margin="normal"
        error={errors.firstName}
        helperText={errors.firstName ? t("first-name-required-error") : ""}
        InputProps={{
          startAdornment: <InputAdornment position="start">{t("doctor-prefix")}</InputAdornment>,
        }}
      />
      <TextField
        fullWidth
        required
        label={t("Last-Name")}
        value={lastName}
        onChange={(e) => {
          setLastName(e.target.value);
          setErrors((prev) => ({ ...prev, lastName: false }));
        }}
        margin="normal"
        error={errors.lastName}
        helperText={errors.lastName ? t("last-name-required-error") : ""}
      />
      <Box mt={2} display="flex">
        <Button
          variant="contained"
          color="primary"
          onClick={handleSubmit}
          disabled={isLoading}
        >
          {isLoading ? t("adding-doctor-loading") : t("add-doctor-button")}
        </Button>
        <Button
          sx={{ mx: 2 }}
          variant="outlined"
          onClick={handleCancel}
          disabled={isLoading}
        >
          {t("back")}
        </Button>
      </Box>
    </Box>
  );
};

export default AddDoctorForm;
